module.exports = "/_next/static/images/hacker-be0c430f6944e84ad34ca2ddaf51b984.png";